/* Senleeto 全站动效/交互 JS 底座
 *
 * 钩子一览（挂在标记上即生效，section 不用写 JS）：
 *   data-reveal              进视口渐显上移
 *   data-stagger             容器，子元素逐个渐显，每个延迟 index×90ms
 *   data-magnetic            鼠标磁性跟随
 *   data-tilt / -tilt-img    卡片 3D 倾斜 + 内图放大
 *   data-acc / -btn / -panel / -icon   折叠面板（颜色交给 CSS，见下）
 *   data-toggle ↔ data-overlay         抽屉/弹层
 *   data-parallax="0.25"     背景视差（本主题新增）
 *   data-hero-line           标题逐行揭示（本主题新增）
 *   data-count + data-count-to  数字滚动（本主题新增）
 *
 * 来源：Design 交付的 designs/senleeto-motion.js，行为逐条保留。
 * Shopify 适配（本主题新增，勿删）：
 *   1. once() 幂等守卫 —— 原版重复 init 会给同一元素重复绑定事件。主题编辑器
 *      每次改设置都会重渲染 section 并重跑脚本，不加守卫会导致磁吸/倾斜/抽屉
 *      多重触发。凡是「绑定事件」的地方都过一次 once()。
 *   2. 底部 shopify:section:load / :select 监听 —— 编辑器里新增或重载 section 后
 *      自动补挂动效，否则新加的模块没有任何动效。
 *   3. init 接受 opts.scope，可只初始化某个 section 范围（默认整个 document）。
 */
(function () {
  /* 幂等守卫：同一元素同一能力只绑一次 */
  function once(el, key) {
    var k = "sltWired" + key;
    if (el.dataset[k] === "1") return false;
    el.dataset[k] = "1";
    return true;
  }

  /* ── 滚动进场：目标表与监听器提到模块作用域 ───────────────────────────────
     原来这些都写在 init 里，每调一次 init 就再挂一对 scroll/resize 监听、
     再建一份 targets。init 是会被反复调的（主题编辑器每次改设置都触发
     shopify:section:load），监听器越积越多。现在全局各一个，init 只往
     revealTargets 里追加元素。 */
  var revealTargets = [];
  var revealArmed = false;

  function prep(el) {
    el.style.opacity = "0";
    el.style.transform = "translateY(28px)";
    el.style.transition = "opacity .8s cubic-bezier(.16,1,.3,1), transform .8s cubic-bezier(.16,1,.3,1)";
  }

  function show(el, d) {
    el.style.transitionDelay = (d || 0) + "ms";
    el.style.opacity = "1";
    el.style.transform = "none";
  }

  function fireReveal(t) {
    if (t.done) return;
    t.done = true;
    if (t.stagger) Array.prototype.forEach.call(t.el.children, function (ch, i) { show(ch, i * 90); });
    else show(t.el, 0);
  }

  function checkReveal() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    revealTargets.forEach(function (t) {
      if (t.done) return;
      var r = t.el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > -40) fireReveal(t);
    });
  }

  /* 进场与数字滚动共用一对监听器，别各挂各的 */
  function checkViewport() {
    checkReveal();
    checkCounts();
  }

  function armReveal() {
    if (revealArmed) return;
    revealArmed = true;
    window.addEventListener("scroll", checkViewport, { passive: true });
    window.addEventListener("resize", checkViewport);
  }

  /* ── 背景视差（data-parallax="0.25"）───────────────────────────────────────
     元素跟随滚动以 rate 倍速反向位移，制造深度。挂在 hero 的背景层上。
     ⚠ 背景层必须比容器高出一截（CSS 里给上下各留 ~15% 的富余），
     否则位移到边缘会露出底色。这里按 overscan 夹住位移量，超出就不再动。 */
  var parallaxItems = [];
  var parallaxArmed = false;
  var parallaxTicking = false;

  function applyParallax() {
    parallaxTicking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    parallaxItems.forEach(function (p) {
      var host = p.el.parentElement;
      if (!host) return;
      var r = host.getBoundingClientRect();
      /* 不在视口内就不算，省得白跑 */
      if (r.bottom < -200 || r.top > vh + 200) return;
      var y = -r.top * p.rate;
      /* 夹住：位移不超过背景层比容器多出来的那部分 */
      var slack = (p.el.offsetHeight - host.offsetHeight) / 2;
      if (slack > 0) {
        if (y > slack) y = slack;
        if (y < -slack) y = -slack;
      }
      p.el.style.transform = "translate3d(0," + y.toFixed(2) + "px,0)";
    });
  }

  function onParallaxScroll() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(applyParallax);
  }

  function armParallax() {
    if (parallaxArmed) return;
    parallaxArmed = true;
    window.addEventListener("scroll", onParallaxScroll, { passive: true });
    window.addEventListener("resize", onParallaxScroll);
  }

  /* ── 数字滚动（data-count + data-count-to）─────────────────────────────────
     进视口后从 0 数到目标值。目标值带小数就保留同样位数，
     不然 420 会数成 420.00。关闭动效时直接落到终值。 */
  var countTargets = [];

  function runCount(t) {
    if (t.done) return;
    t.done = true;
    var dur = 1200;
    var start = null;
    var step = function (ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      /* easeOutCubic，和整套缓动同调性 */
      var e = 1 - Math.pow(1 - p, 3);
      var v = t.to * e;
      t.el.textContent = t.decimals ? v.toFixed(t.decimals) : Math.round(v).toString();
      if (p < 1) window.requestAnimationFrame(step);
      else t.el.textContent = t.decimals ? t.to.toFixed(t.decimals) : Math.round(t.to).toString();
    };
    window.requestAnimationFrame(step);
  }

  function checkCounts() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    countTargets.forEach(function (t) {
      if (t.done) return;
      var r = t.el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > -40) runCount(t);
    });
  }

  /* ── 标题逐行揭示（data-hero-line）─────────────────────────────────────────
     母版：外层 overflow:hidden，内层从 translateY(115%) 升到 0，.9s，
     逐行延迟 .1s / .24s / .4s。hero 在首屏，不等滚动，挂上就放。 */
  var HERO_LINE_DELAYS = [100, 240, 400];

  window.SenleetoMotion = {
    init: function (opts) {
      opts = opts || {};
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var motion = opts.motion || "full";
      var off = reduce || motion === "off";
      var full = !off && motion === "full";
      var root = opts.scope || document;

      // reveal (scroll-position based)
      if (!off) {
        root.querySelectorAll("[data-reveal]").forEach(function (el) { if (!once(el, "Reveal")) return; prep(el); revealTargets.push({ el: el, stagger: false, done: false }); });
        root.querySelectorAll("[data-stagger]").forEach(function (c) { if (!once(c, "Stagger")) return; Array.prototype.forEach.call(c.children, prep); revealTargets.push({ el: c, stagger: true, done: false }); });
        armReveal();
        checkViewport(); setTimeout(checkViewport, 250);
        /* 兜底：4 秒后无论有没有进视口都放出来，避免因为布局异常永远隐身 */
        setTimeout(function () { revealTargets.forEach(fireReveal); }, 4000);
      }

      /* 数字滚动。
         ⚠ 标记里写的是**真值**，不是 0 —— 爬虫、无 JS、脚本加载失败的环境
         都不会跑到这里，写 0 的话那些环境永远看到 0。
         所以归零是这里的责任：只有在确定要做动画时才把它压到 0 再数上来。
         off 时什么都不做，真值原样留在页面上。 */
      root.querySelectorAll("[data-count]").forEach(function (el) {
        if (!once(el, "Count")) return;
        if (off) return;
        var raw = el.getAttribute("data-count-to");
        var to = parseFloat(raw);
        if (isNaN(to)) return;
        var dot = raw.indexOf(".");
        var decimals = dot === -1 ? 0 : raw.length - dot - 1;
        el.textContent = decimals ? (0).toFixed(decimals) : "0";
        countTargets.push({ el: el, to: to, decimals: decimals, done: false });
      });
      if (!off) {
        armReveal();
        checkCounts(); setTimeout(checkCounts, 250);
        /* 同样给兜底，别让数字永远停在 0 */
        setTimeout(function () { countTargets.forEach(runCount); }, 4000);
      }

      /* 背景视差。basic 级别也保留 —— 它是位置而非装饰性动画，
         观感上属于「页面本身」，关掉反而显得生硬。off 才停。 */
      if (!off) {
        root.querySelectorAll("[data-parallax]").forEach(function (el) {
          if (!once(el, "Parallax")) return;
          var rate = parseFloat(el.getAttribute("data-parallax"));
          if (isNaN(rate)) rate = 0.25;
          el.style.willChange = "transform";
          parallaxItems.push({ el: el, rate: rate });
        });
        if (parallaxItems.length) { armParallax(); applyParallax(); }
      }

      /* 标题逐行揭示。hero 在首屏，不等滚动，双 rAF 后直接放。
         每次 init 单独计数，避免多个 hero 时延迟串号。

         ⚠ 初始的 translateY(115%) 写在 CSS 里（避免脚本执行前先闪一下正常位置），
         所以**不管动效开不开，这里都必须把它放出来**，否则关掉动效等于把标题藏死。
         off 的时候不加过渡，直接落位。CSS 侧另有 html.no-js 的兜底。 */
      var lineIndex = 0;
      root.querySelectorAll("[data-hero-line]").forEach(function (el) {
        if (!once(el, "HeroLine")) return;
        if (off) { el.style.transform = "none"; return; }
        var d = HERO_LINE_DELAYS[lineIndex] !== undefined
          ? HERO_LINE_DELAYS[lineIndex]
          : 100 + lineIndex * 160;
        lineIndex++;
        el.style.transition = "transform .9s cubic-bezier(.16,1,.3,1)";
        el.style.transitionDelay = d + "ms";
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { el.style.transform = "none"; });
        });
      });

      // magnetic
      if (full) {
        root.querySelectorAll("[data-magnetic]").forEach(function (el) {
          if (!once(el, "Magnetic")) return;
          el.style.transition = "transform .35s cubic-bezier(.16,1,.3,1)"; el.style.willChange = "transform";
          el.addEventListener("mousemove", function (ev) { var r = el.getBoundingClientRect(); el.style.transform = "translate(" + ((ev.clientX - r.left - r.width / 2) * 0.28) + "px," + ((ev.clientY - r.top - r.height / 2) * 0.4) + "px)"; });
          el.addEventListener("mouseleave", function () { el.style.transform = "translate(0,0)"; });
        });
      }

      // tilt
      if (full) {
        root.querySelectorAll("[data-tilt]").forEach(function (card) {
          if (!once(card, "Tilt")) return;
          var img = card.querySelector("[data-tilt-img]");
          card.style.transition = "opacity .8s cubic-bezier(.16,1,.3,1), transform .4s cubic-bezier(.16,1,.3,1), box-shadow .4s ease";
          card.addEventListener("mousemove", function (ev) {
            var r = card.getBoundingClientRect();
            var px = (ev.clientX - r.left) / r.width - 0.5, py = (ev.clientY - r.top) / r.height - 0.5;
            card.style.transform = "perspective(900px) rotateX(" + (-py * 5) + "deg) rotateY(" + (px * 6) + "deg) translateY(-6px)";
            card.style.boxShadow = "0 26px 50px rgba(24,26,20,.16)";
            if (img) img.style.transform = "scale(1.06)";
          });
          card.addEventListener("mouseleave", function () { card.style.transform = "perspective(900px) rotateX(0) rotateY(0) translateY(0)"; card.style.boxShadow = ""; if (img) img.style.transform = "scale(1)"; });
        });
      }

      // accordion
      root.querySelectorAll("[data-acc]").forEach(function (item) {
        if (!once(item, "Acc")) return;
        var btn = item.querySelector("[data-acc-btn]");
        var panel = item.querySelector("[data-acc-panel]");
        var icon = item.querySelector("[data-acc-icon]");
        if (!btn || !panel) return;
        /* 只管状态与几何，颜色交给 CSS：
           item 上会有 data-open="true|false"，各 section 自己写
           [data-acc][data-open="true"] [data-acc-icon] 的样式。
           （原来这里直接写死 #0F3322 / #1E5638 / #E7DECE，既违反「颜色走后台
           配色方案」，也会在没做过图标底样式的地方凭空糊出一块深色方块。） */
        /* 2026-08-07 重写高度动画。原来是一行：
             panel.style.height = open ? panel.scrollHeight + "px" : "0px";
           两个硬伤，用户实机描述为「停一下 → 突然撑开，下方元素瞬间跳位」：
           ① 展开后永远停在写死的 px，从不回 auto。图片加载 / 富文本重排后高度对不上，
              recompute() 一跑就是无过渡的瞬间跳变。
           ② 收起时没有强制回流：从 auto（或未定值）直接写 0px，浏览器当成同一帧里的
              单次赋值，**过渡根本不产生**，所以是瞬间合上。
           母版之所以连续，是因为高度全程有中间值可插值。
           修法：展开 0→px，transitionend 后置 auto；收起先把 auto 固定成 px、
           强制回流、下一帧再到 0。data-open 与 icon 的契约原样保留。 */
        var isOpen = function () { return item.getAttribute("data-open") === "true"; };

        var setOpen = function (open, instant) {
          item.setAttribute("data-open", open ? "true" : "false");
          if (icon) icon.style.transform = open ? "rotate(180deg)" : "rotate(0)";

          if (instant) { panel.style.height = open ? "auto" : "0px"; return; }

          if (open) {
            panel.style.height = panel.scrollHeight + "px";
            /* 动画结束后交还给 auto，内容再变高也不会被裁 */
            var done = function (e) {
              if (e.target !== panel || e.propertyName !== "height") return;
              panel.removeEventListener("transitionend", done);
              if (isOpen()) panel.style.height = "auto";
            };
            panel.addEventListener("transitionend", done);
          } else {
            /* auto → px → 强制回流 → 0px，缺了中间这步就没有过渡 */
            panel.style.height = panel.scrollHeight + "px";
            void panel.offsetHeight;
            requestAnimationFrame(function () { panel.style.height = "0px"; });
          }
        };

        setOpen(item.getAttribute("data-acc") === "true", true);
        btn.addEventListener("click", function () { setOpen(!isOpen()); });
      });
      var recompute = function () {
        root.querySelectorAll("[data-acc]").forEach(function (item) {
          var panel = item.querySelector("[data-acc-panel]");
          /* 展开态现在是 height:auto，本来就会自适应，不用（也不能）再写死 px ——
             以前这里一写就是无过渡的跳变。只兜底修复历史遗留的 px 值。 */
          if (panel && item.getAttribute("data-open") === "true" && panel.style.height !== "auto") {
            panel.style.height = "auto";
          }
        });
      };
      window.addEventListener("resize", recompute);
      window.addEventListener("load", recompute);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(recompute);
      setTimeout(recompute, 300); setTimeout(recompute, 900);

      // overlays
      /* 弹层一律在整个 document 里找，不受 scope 限制 ——
         触发钮在 header、弹层可能挂在别处；scope 化会导致找不到。 */
      var allOverlays = function () { return Array.prototype.slice.call(document.querySelectorAll("[data-overlay]")); };
      var closeOv = function (ov) {
        var panel = ov.querySelector("[data-ov-panel]"); var bd = ov.querySelector("[data-ov-backdrop]");
        if (bd) bd.style.opacity = "0";
        if (panel) { panel.style.opacity = "0"; panel.style.transform = panel.getAttribute("data-closed-transform") || "translateY(-14px)"; }
        ov.setAttribute("data-open", "false");
        setTimeout(function () { if (ov.getAttribute("data-open") !== "true") ov.style.display = "none"; }, 400);
      };
      var openOv = function (ov) {
        ov.style.display = "block"; ov.setAttribute("data-open", "true");
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          var panel = ov.querySelector("[data-ov-panel]"); var bd = ov.querySelector("[data-ov-backdrop]");
          if (bd) bd.style.opacity = "1";
          if (panel) { panel.style.opacity = "1"; panel.style.transform = "none"; }
        }); });
      };
      root.querySelectorAll("[data-toggle]").forEach(function (btn) {
        if (!once(btn, "Toggle")) return;
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          var ov = document.querySelector('[data-overlay="' + btn.getAttribute("data-toggle") + '"]');
          if (!ov) return;
          if (ov.getAttribute("data-open") === "true") { closeOv(ov); return; }
          allOverlays().forEach(function (o) { if (o !== ov && o.getAttribute("data-open") === "true") closeOv(o); });
          openOv(ov);
        });
      });
      root.querySelectorAll("[data-ov-close]").forEach(function (el) {
        if (!once(el, "OvClose")) return;
        el.addEventListener("click", function (e) { e.preventDefault(); var ov = el.closest("[data-overlay]"); if (ov) closeOv(ov); });
      });

      /* Esc 关闭：全局只绑一次，否则每次 init 都会多加一个监听 */
      if (!document.documentElement.dataset.sltWiredEsc) {
        document.documentElement.dataset.sltWiredEsc = "1";
        document.addEventListener("keydown", function (e) {
          if (e.key !== "Escape") return;
          document.querySelectorAll('[data-overlay][data-open="true"]').forEach(function (o) {
            var panel = o.querySelector("[data-ov-panel]"), bd = o.querySelector("[data-ov-backdrop]");
            if (bd) bd.style.opacity = "0";
            if (panel) { panel.style.opacity = "0"; panel.style.transform = panel.getAttribute("data-closed-transform") || "translateY(-14px)"; }
            o.setAttribute("data-open", "false");
            setTimeout(function () { if (o.getAttribute("data-open") !== "true") o.style.display = "none"; }, 400);
          });
        });
      }
    }
  };

  /* ── 全站自动接入 ─────────────────────────────────────────────────────────
     以前只有 Living header 自己调 init，别处想要动效就得各自写一段脚本。
     现在本文件由 theme.liquid 全局加载并自己初始化一次，scope 是整个 document，
     任何 section 只要在标记上挂 data-reveal / data-stagger / data-magnetic /
     data-tilt / data-acc / data-toggle 就自动生效，不用写 JS。
     幂等由 once() 保证，重复 init 不会重复绑定。

     动效级别取自 theme.liquid 写下的 window.SenleetoMotionLevel（后台主题设置）。
     系统开启「减少动态效果」的访客在 init 里另有判断，一律关闭。 */
  function level() {
    return window.SenleetoMotionLevel || "full";
  }

  function autoInit() {
    window.SenleetoMotion.init({ motion: level() });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", autoInit);
  else autoInit();

  /* 主题编辑器里新增/重载 section 后自动补挂动效。
     不加这段，编辑器里新加的模块不会有任何动效，要刷新页面才出现。 */
  document.addEventListener("shopify:section:load", function (e) {
    window.SenleetoMotion.init({ scope: e.target, motion: level() });
  });
})();
